import { ROUTES, type Customer } from '@serb/shared';
import { api } from '../../api/client';
import { useVaultRecords } from '../claudeTasks/useVaultRecords';

/** The customers, read from the Serb Mind vault */
export const useCustomers = () =>
  useVaultRecords<Customer>('customers', 'Customer', () => api.get(ROUTES.api.customers));
